module.exports = __webpack_public_path__ + "img/weixingxuanju09314-1.prt.7c0910c7.jpg";